import React, { useState } from 'react';
import { Form, Input } from '@rocketseat/unform';
import { useDispatch } from 'react-redux';
import { MdVisibilityOff, MdVisibility } from 'react-icons/md';
import { Container } from './styles';

import { changePasswordRequest } from '~/store/modules/user/actions';

import { store } from '~/store';

export default function ChangePassword() {
  const dispatch = useDispatch();

  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');

  const [hiddenInput, setHiddenInput] = useState(true);
  const [hiddenInputNewPassword, setHiddenInputNewPassword] = useState(true);
  const [hiddenInputConfirmPassowrd, setHiddenInputConfirmPassword] = useState(
    true
  );

  async function handleSubmit(data) {
    const { token } = store.getState().auth;

    // if (!password || !newPassword || !confirmNewPassword) return;

    dispatch(changePasswordRequest(token, data));
  }

  function handleToggleShowPassword(e) {
    if (e.target.id === 'imageInput') {
      setHiddenInput(!hiddenInput);
    }
    if (e.target.id === 'imageInput2') {
      setHiddenInputNewPassword(!hiddenInputNewPassword);
    }
    if (e.target.id === 'imageInput3') {
      setHiddenInputConfirmPassword(!hiddenInputConfirmPassowrd);
    }
  }

  return (
    <Container>
      <Form onSubmit={handleSubmit}>
        <h2>Alterar Senha</h2>
        <div className="inputClass">
          <div>Senha atual</div>
          <Input
            maxLength="100"
            name="password"
            placeholder="********"
            type={hiddenInput ? 'password' : 'text'}
            value={password}
            onChange={e => {
              setPassword(e.target.value);
            }}
          />
          {hiddenInput ? (
            <MdVisibilityOff
              id="imageInput"
              size={25}
              onClick={handleToggleShowPassword}
            />
          ) : (
            <MdVisibility
              id="imageInput"
              size={25}
              onClick={handleToggleShowPassword}
            />
          )}
        </div>
        <div className="inputClass">
          <div>Nova senha</div>
          <Input
            maxLength="100"
            name="newPassword"
            placeholder="********"
            type={hiddenInputNewPassword ? 'password' : 'text'}
            value={newPassword}
            onChange={e => {
              setNewPassword(e.target.value);
            }}
          />
          {hiddenInputNewPassword ? (
            <MdVisibilityOff
              id="imageInput2"
              size={25}
              onClick={handleToggleShowPassword}
            />
          ) : (
            <MdVisibility
              id="imageInput2"
              size={25}
              onClick={handleToggleShowPassword}
            />
          )}
        </div>
        <div className="inputClass">
          <div>Confirmar nova senha</div>
          <Input
            maxLength="100"
            name="confirmNewPassword"
            placeholder="********"
            type={hiddenInputConfirmPassowrd ? 'password' : 'text'}
            value={confirmNewPassword}
            onChange={e => {
              setConfirmNewPassword(e.target.value);
            }}
          />
          {hiddenInputConfirmPassowrd ? (
            <MdVisibilityOff
              id="imageInput3"
              size={25}
              onClick={handleToggleShowPassword}
            />
          ) : (
            <MdVisibility
              id="imageInput3"
              size={25}
              onClick={handleToggleShowPassword}
            />
          )}
        </div>

        <button type="submit">Salvar</button>
      </Form>
    </Container>
  );
}
